/* FieldOrSelectEditor.js */

"use strict";

/**
 * @typedef {{Control: {
 *  Textfield: {Textarea: TextareaControlComponent, InputText:InputTextControlComponent, InputNumber:InputNumberControlComponent},
 *  OptionSelection: {Single:{ComboBox:ComboBoxControlComponent}, Multiple:{ComboBox:MultipleComboBoxControlComponent}}
 *  Boolean: {InputCheckbox:InputCheckboxControlComponent}
 * }}} uiCoreTools
 */

/**
 * @type {uiCoreTools}
 */

const uiCore = require("@gluenetworks/steve_ui_core");
const InputTextControl = uiCore.Control.Textfield.InputText;
const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
require("@gluenetworks/jstree");
const $ = require("jquery");
const _ = require("lodash");

class FieldOrSelectEditor {
    constructor(options) {
        this._options = options;
        const columnData = options.column;
        const itemData = options.item;

        this.gridInstance = options.grid;
        this.cancelChanges = options.cancelChanges;
        this.commitChanges = options.commitChanges;

        this._itemData = itemData;
        this._isNewItem = Boolean(itemData.isNew);
        this._fieldName = columnData.field;
        this._$container = document.body; //options.container;
        this._$container.style.overflow = "hidden";

        this._mode = "";

        this._createInput(this._itemData);
    }

    _createInput() {
        if (this._itemData.syncDirection === "CI_TO_DEVICE") {
            if (this._fieldName === "sourceField") {
                this.initialData = _.cloneDeep(this._itemData);
                this._createSelectBox();
            } else if (this._fieldName === "destField") {
                this.initialData = this._itemData[this._fieldName];
                this._createFieldEditor();
            }
        } else if (this._itemData.syncDirection === "DEVICE_TO_CI") {
            if (this._fieldName === "sourceField") {
                this.initialData = this._itemData[this._fieldName];
                this._createFieldEditor();
            } else if (this._fieldName === "destField") {
                this.initialData = _.cloneDeep(this._itemData);
                this._createSelectBox();
            }
        }
    }

    _createSelectBox() {
        this.rootElement = this._createSelectBoxRootElement(this._fieldName);
        Object.assign(this.rootElement.style, {
            minWidth: this._options.position.width + "px",
            minHeight: this._options.position.height + "px",
        });
        this.position(this._options.position);
        this.rootElement.classList.add("select");
        this.input = this._createSelectComboBox();
        this._initSelectBox();
    }

    _createFieldEditor() {
        this.rootElement = this._createRootElement(this._fieldName);
        Object.assign(this.rootElement.style, {
            minWidth: this._options.position.width + "px",
            minHeight: this._options.position.height + "px",
        });
        this.position(this._options.position);
        this.input = this._createFieldEditorInput(this._itemData);
        this.inputTxt = new InputTextControl({
            darkTheme: false,
            placeholder: "Enter search term",
        });

        this._onUserValue = this._onUserValue.bind(this);
        this._onRootBlur = _.debounce(this._onRootBlur.bind(this), 50);

        this._initFieldEditor();
    }

    _initFieldEditor() {
        this.rootElement.prepend(this.inputTxt.renderer.rootElement);
        this._renderFieldEditor();
        this._registerFieldListeners();
    }

    _initSelectBox() {
        let dropDownData = _.get(this._itemData, "ciAttributesDropDownData", []);

        if (this._itemData.syncDirection === "DEVICE_TO_CI" && this._fieldName === "destField") {
            dropDownData = this._filterDropDownData(
                this._itemData.ciAttributesDropDownData,
                this._itemData.devicePropType
            );
        }

        this.input.setOptions(dropDownData);
        this.rootElement.append(this.input.renderer.rootElement);
        this._$container.append(this.rootElement);

        this._onUserValue = this._onUserValue.bind(this);
        this._onRootBlur = _.debounce(this._onRootBlur.bind(this), 50);

        this.input.setValue(_.get(this._itemData, "cmdbAttr", ""));
        this.focus();
        this._registerSelectBoxListeners();
    }

    _renderFieldEditor() {
        this._$container.append(this.rootElement);
        this.inputTxt.focus();
    }

    _registerSelectBoxListeners() {
        this.rootElement.addEventListener(
            "keydown",
            (this._onRootKeydown = this._onRootKeydown.bind(this))
        );

        this.rootElement.addEventListener(
            "click",
            (this._onRootClick = this._onRootClick.bind(this))
        );
        this.input.addListener("UserValue", this._onUserValue);
    }

    _unregisterSelectBoxListeners() {
        this.rootElement.removeEventListener("keydown", this._onRootKeydown);
        this.rootElement.removeEventListener("click", this._onRootClick);
        if (this.input) {
            this.input.removeListener("UserValue", this._onUserValue);
        }
    }

    _registerFieldListeners() {
        this.rootElement.addEventListener(
            "keydown",
            (this._onRootKeydown = this._onRootKeydown.bind(this))
        );

        this.rootElement.addEventListener(
            "click",
            (this._onRootClick = this._onRootClick.bind(this))
        );
        this.rootElement.addEventListener("blur", this._onRootBlur);
        this.inputTxt.addListener("UserValue", this._onUserValue);
        this.inputTxt.addListener("UserBlur", this._onRootBlur);
    }

    _unregisterFieldListeners() {
        this.rootElement.removeEventListener("keydown", this._onRootKeydown);
        this.rootElement.removeEventListener("click", this._onRootClick);
        this.rootElement.removeEventListener("blur", this._onRootBlur);
        this.inputTxt.removeListener("UserValue", this._onUserValue);
        this.inputTxt.removeListener("UserBlur", this._onRootBlur);
    }

    hide() {}
    show() {}

    _onUserValue(val) {
        if (this._itemData.syncDirection === "CI_TO_DEVICE") {
            if (this._fieldName === "sourceField") {
                _.set(this._itemData, "cmdbAttr", val);
                const typeVal = _.get(
                    _.find(this._itemData.ciAttributesDropDownData, (item) => item.value === val),
                    "type"
                );
                _.set(this._itemData, "cmdbAttrType", typeVal);
                this._value = this._itemData;
            } else if (this._fieldName === "destField") {
                this.input.jstree(true).search(val);
            }
        } else if (this._itemData.syncDirection === "DEVICE_TO_CI") {
            if (this._fieldName === "sourceField") {
                this.input.jstree(true).search(val);
            } else if (this._fieldName === "destField") {
                _.set(this._itemData, "cmdbAttr", val);
                const typeVal = _.get(
                    _.find(this._itemData.ciAttributesDropDownData, (item) => item.value === val),
                    "type"
                );
                _.set(this._itemData, "cmdbAttrType", typeVal);
                this._value = this._itemData;
            }
        }
    }

    /**
     *
     * @param {KeyboardEvent} e
     * @private
     */
    _onRootKeydown(e) {
        const isArrow = e.key.toLowerCase().match("arrow");
        const isEnter = e.key.toLowerCase() === "enter";
        const isEsc = e.key.toLowerCase() === "escape";
        const withCommand = e.metaKey || e.ctrlKey;

        const onInput = e.target.tagName === "INPUT";
        const onTextArea = e.target.tagName === "TEXTAREA";

        if ((onInput && isArrow) || (onTextArea && (isArrow || isEnter))) {
            // do not lose editor on arrow navigation in inputs
            e.stopPropagation();
        }

        if ((isEnter && withCommand) || (isEnter && onInput)) {
            this._save();
            e.stopPropagation();
        }

        if (isEsc) {
            this._cancel();
        }
    }
    _onRootClick(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    _onRootBlur() {
        // de - editor - wrapper field - editor
        if (
            document.activeElement.className.search("jstree") >= 0 ||
            document.activeElement.className.search("de-editor-wrapper") >= 0
        ) {
            return;
        }

        if (document.activeElement.tagName === "INPUT") {
            if (
                document.activeElement.parentElement.parentElement.className.search(
                    "de-editor-wrapper"
                ) >= 0
            ) {
                return;
            }
        }

        _.delay(() => {
            this.gridInstance && this.gridInstance.getEditorLock().commitCurrentEdit();
        }, 100);
    }

    _createRootElement(fieldName) {
        const rootElement = document.createElement("div");
        rootElement.classList.add("de-editor-wrapper", `${fieldName}-editor`);
        rootElement.setAttribute("tabindex", 0);
        rootElement.component = this;
        return rootElement;
    }

    _createFieldEditorInput(data) {
        this._treeTestCont = document.createElement("div");
        this._treeTestCont.classList.add("tree-selector");
        this.rootElement.appendChild(this._treeTestCont);
        let treeData = data.deviceNodeTreeData;
        const explorables = data.solutions;
        if (this._itemData.syncDirection === "CI_TO_DEVICE" && this._fieldName === "destField") {
            treeData = this._generateTreeDataForNodePropsFiltered(explorables, data.cmdbAttrType);
        }

        const treeSelector = $(this._treeTestCont).jstree({
            core: {
                data: treeData,
                themes: {
                    dots: false,
                },
            },
            search: {
                show_only_matches: true,
                show_only_matches_children: true,
            },
            plugins: ["search"],
        });

        $(this._treeTestCont).on("changed.jstree", (e, data) => {
            const name = data.node.text;
            const parents = [];
            let fullName = "";
            let field = explorables;
            if (data.node.parents.length > 1) {
                for (let i = data.node.parents.length - 2; i >= 0; i--) {
                    parents.push(data.instance.get_node(data.node.parents[i]).text);
                    field = field[data.instance.get_node(data.node.parents[i]).text];
                    fullName += data.instance.get_node(data.node.parents[i]).text + ">";
                }
            }
            field = field[name];
            fullName += name;
            if (!field.path) {
                return;
            }
            this._value = fullName;
            data.instance.close_all();
            this.gridInstance.getEditorLock().commitCurrentEdit();
        });
        return treeSelector;
    }

    _createSelectComboBox() {
        return new SingleComboBoxControl({
            showFilter: true,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    _getValue() {
        // return this.input.getValue();
        return this._value;
    }

    _cancel() {
        // this.input.setValue(this.initialData);
        this.cancelChanges();
    }

    _save() {
        this.commitChanges();
    }

    _createSelectBoxRootElement(fieldName) {
        const rootElement = document.createElement("div");
        rootElement.classList.add("editor-wrapper", `${fieldName}-editor`);
        rootElement.component = this;
        return rootElement;
    }
    /*****************************/
    /*       PUBLIC API          */
    /*****************************/
    destroy() {
        if (this._itemData.syncDirection === "CI_TO_DEVICE") {
            if (this._fieldName === "sourceField") {
                this._shutdownSelectBoxValues();
            } else if (this._fieldName === "destField") {
                this._shutdownFieldValues();
            }
        } else if (this._itemData.syncDirection === "DEVICE_TO_CI") {
            if (this._fieldName === "sourceField") {
                this._shutdownFieldValues();
            } else if (this._fieldName === "destField") {
                this._shutdownSelectBoxValues();
            }
        }
    }

    _shutdownFieldValues() {
        this._unregisterFieldListeners();
        this.rootElement.remove();
        this._$container.style.removeProperty("overflow");
        return Promise.resolve()
            .then(/*() => this.input.destroy()*/ () => Promise.resolve())
            .then(() => {
                this.input = null;
                this.rootElement = null;
                this.gridInstance = null;
                this._$container = null;
                this._itemData = null;
            });
    }

    _shutdownSelectBoxValues() {
        this._unregisterSelectBoxListeners();
        this.rootElement.remove();
        this._$container.style.removeProperty("overflow");
        return Promise.resolve()
            .then(() => (this.input ? this.input.shutdown() : Promise.resolve()))
            .then(() => {
                this.input = null;
                this.rootElement = null;
                this.gridInstance = null;
                this._$container = null;
                this._itemData = null;
            });
    }

    focus() {
        // this.input.focus();
    }

    // show() {
    //     this.rootElement.style.removeProperty("display");
    // }

    // hide() {
    //     this.rootElement.style.setProperty("display", "none");
    // }

    position({top, left}) {
        Object.assign(this.rootElement.style, {
            top: `${top}px`,
            left: `${left}px`,
        });
    }

    /**
     * is used to load value from item Data and set it to 'input'
     * @param {ItemData} item
     */
    loadValue(item) {
        const fieldValue = item[this._fieldName];
        if (!fieldValue) {
            return;
        }
        this.initialData = fieldValue;
        // this.input.setValue(fieldValue);
    }

    /**
     * is used to get data from 'input'
     * @returns {*}
     */
    serializeValue() {
        return this._getValue();
    }

    /**
     * is used to apply new data back to Item
     * @param {ItemData} item - grid data Item
     * @param {*} state - result of serializeValue
     */
    applyValue(item, state) {
        if (this._itemData.syncDirection === "CI_TO_DEVICE") {
            if (this._fieldName === "sourceField") {
                this._applyCiAttr(item, state);
            } else if (this._fieldName === "destField") {
                this._applyDeviceProp(item, state);
            }
        } else if (this._itemData.syncDirection === "DEVICE_TO_CI") {
            if (this._fieldName === "sourceField") {
                this._applyDeviceProp(item, state);
            } else if (this._fieldName === "destField") {
                this._applyCiAttr(item, state);
            }
        }
    }

    _applyCiAttr() {}

    _applyDeviceProp(item, state) {
        if (!state) {
            return;
        }
        item[this._fieldName] = state;
        const path = state.split(">");
        const explorables = item.solutions;
        const fl = path.reduce((acc, val) => {
            return acc[val];
        }, explorables);

        item.devicePropPath = fl.path;
        item.devicePropType = fl.dataType;
    }

    /**
     * Compares initial and edited data.
     * If false the destroy will be called the next.
     * If true validate will be called the next.
     * @returns {boolean}
     */
    isValueChanged() {
        return JSON.stringify(this.initialData) !== JSON.stringify(this._getValue());
    }

    /**
     * checks if data is valid
     *
     * @returns {{valid: boolean, msg: ?string}}
     */

    validate() {
        // const isInvalid = this.input.isInvalid();
        // const msg = typeof isInvalid === "string" ? isInvalid : null;
        return {
            valid: true,
            msg: "",
        };
    }

    /**
     * Filter The Device Prop values based on CiAttribute value
     */

    _generateTreeDataForNodePropsFiltered(explorables, dataType) {
        const restructured = [];
        for (let key in explorables) {
            const nodeData = explorables[key];
            restructured.push(this._generateTreeNodeForNodeProps(key, nodeData, dataType));
        }
        return restructured.filter((item) => item.children && item.children.length > 0);
    }

    _generateTreeNodeForNodeProps(name, nodeData, dataType) {
        if (!nodeData.path) {
            const node = {};
            node.text = name;
            node.children = [];
            for (let key in nodeData) {
                if (this._shouldIncludeNodeCiToDA(nodeData[key], dataType)) {
                    node.children.push(
                        this._generateTreeNodeForNodeProps(key, nodeData[key], dataType)
                    );
                }
            }
            return node;
        }
        return name;
    }

    _shouldIncludeNodeCiToDA(nodeData, dataType) {
        const typeRules = {
            string: ["string"],
            GUID: ["string"],
            ip_addr: ["string"],
            integer: ["number", "duration", "string"],
            decimal: ["number", "string"],
            float: ["number", "string"],
            boolean: ["boolean"],
            glide_date_time: ["unixTime", "string"],
            glide_date: ["unixTime", "string"],
        };

        if (dataType in typeRules) {
            return typeRules[dataType].includes(nodeData.dataType);
        }

        return false;
    }

    _shouldIncludeDeviceProp(nodeData, dataType) {
        const typeRules = {
            string: ["string", "GUID", "ip_addr"],
            number: ["integer", "decimal", "float", "string"],
            duration: ["integer"],
            boolean: ["boolean"],
            unixTime: ["glide_date_time", "glide_date"],
            enum: ["string"],
        };

        if (dataType in typeRules) {
            return typeRules[dataType].includes(nodeData.type);
        }

        return false;
    }

    _filterDropDownData(dropDownData, dataType) {
        const filteredDropDownList = dropDownData.filter((item) =>
            this._shouldIncludeDeviceProp(item, dataType)
        );
        return filteredDropDownList;
    }
}

module.exports = FieldOrSelectEditor;
